import {Navbar} from './Navbar';

export default function Header() {
  return (
    <>
      <Navbar
        links={[
          {
            link: '/quality-healthcare-admin/contacts',
            label: 'Messages',
          },
          {
            link: '/quality-healthcare-admin/applications',
            label: 'Applications',
          },
          {
            link: '/quality-healthcare-admin/vacancies',
            label: 'Vacancies',
          },
        ]}
      />
    </>
  );
}
